import { useBetsOnce, useUnfilledBets } from 'client-common/hooks/use-bets'
import { useTranslation } from 'react-i18next'
import { Bet, LimitBet } from 'common/bet'
import { Contract } from 'common/contract'
import { ContractMetric } from 'common/contract-metric'
import { sortBy, uniqBy } from 'lodash'
import { ContractBetsTable } from 'web/components/bet/contract-bets-table'
import { YourOrders } from 'web/components/bet/order-book'
import { Col } from 'web/components/layout/col'
import { useIsPageVisible } from 'web/hooks/use-page-visible'
import { useUser } from 'web/hooks/use-user'
import { api } from 'web/lib/api/api'

export function YourTrades(props: {
  contract: Contract
  contractMetric: ContractMetric | undefined
  yourNewBets: Bet[]
}) {
  const { contract, contractMetric, yourNewBets } = props
  const { t } = useTranslation()
  const user = useUser()

  const staticBets = useBetsOnce((params) => api('bets', params), {
    contractId: contract.id,
    userId: !user ? 'loading' : user.id,
    order: 'asc',
  })

  const userBets = sortBy(
    uniqBy([...yourNewBets, ...(staticBets ?? [])], 'id'),
    'createdTime'
  )
  const visibleUserBets = userBets.filter(
    (bet) => !bet.isRedemption && bet.amount !== 0
  )

  const allLimitBets =
    contract.mechanism === 'cpmm-1'
      ? // eslint-disable-next-line react-hooks/rules-of-hooks
        useUnfilledBets(
          contract.id,
          (params) => api('bets', params),
          useIsPageVisible,
          { enabled: true }
        ) ?? []
      : []
  const userLimitBets = allLimitBets.filter(
    (bet) => bet.userId === user?.id
  ) as LimitBet[]

  if (
    (userLimitBets.length === 0 || contract.mechanism != 'cpmm-1') &&
    visibleUserBets.length === 0
  ) {
    return null
  }

  return (
    <Col className="bg-canvas-50 rounded py-4 pb-0 sm:px-3">
      {contract.mechanism === 'cpmm-1' && (
        <YourOrders
          contract={contract}
          bets={userLimitBets}
          deemphasizedHeader
        />
      )}

      {visibleUserBets.length > 0 && contractMetric && (
        <>
          <div className="pl-2 font-semibold">{t('contract.yourTrades')}</div>
          <ContractBetsTable
            contractMetric={contractMetric}
            contract={contract}
            bets={userBets}
            isYourBets
          />
        </>
      )}
    </Col>
  )
}
